import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { LibraryComponentProps } from './types';

const LibraryComponent: React.FC<LibraryComponentProps> = ({ LibraryData, onCellClick }) => {
   return (
      <Box
         sx={{
            position: 'absolute',
            top: 64,
            right: 16,
            zIndex: 20,
            display: 'flex',
            justifyContent: 'flex-end',
         }}
      >
         <TableContainer
            component={Paper}
            style={{ background: '#ffffff', maxWidth: '250px', border: '1px solid lightgray' }}
         >
            <Table sx={{ minWidth: 150 }} aria-label='scodix-ai1 table'>
               <TableHead>
                  <TableRow>
                     <TableCell align='left' sx={{ padding: '12px' }}>
                        <Box
                           style={{ color: '#abababab' }}
                           gap={1}
                           sx={{ display: 'flex', alignItems: 'center' }}
                        >
                           ID
                        </Box>
                     </TableCell>
                     <TableCell align='left' sx={{ padding: '12px' }}>
                        <Box
                           style={{ color: '#abababab' }}
                           gap={1}
                           sx={{ display: 'flex', alignItems: 'center' }}
                        >
                           Examples Jobs
                        </Box>
                     </TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {LibraryData.length > 0 &&
                     LibraryData.map(
                        (value, index) =>
                           value.visible && (
                              <TableRow
                                 key={value.job}
                                 sx={{
                                    '&:hover': {
                                       backgroundColor: 'gray',
                                       '& *': { color: 'white' },
                                    },
                                 }}
                              >
                                 <TableCell
                                    style={{ color: '#abababab' }}
                                    align='left'
                                    sx={{ padding: '12px' }}
                                 >
                                    {index + 1}
                                 </TableCell>
                                 <TableCell
                                    style={{ color: '#abababab', cursor: 'pointer' }}
                                    align='left'
                                    sx={{ padding: '12px' }}
                                    onClick={() => onCellClick(value.job)}
                                 >
                                    {value.job}
                                 </TableCell>
                              </TableRow>
                           ),
                     )}
               </TableBody>
            </Table>
         </TableContainer>
      </Box>
   );
};

export default LibraryComponent;
